import { render, staticRenderFns } from "./AddBSDevice.vue?vue&type=template&id=f1d71ff4&"
import script from "./AddBSDevice.vue?vue&type=script&lang=js&"
export * from "./AddBSDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports